/**
 * Constants
 */
// Env
const IS_SERVER = typeof window === 'undefined';
// @ts-ignore - window is not defined in core, but it is in psl
const PSL_ENV = IS_SERVER ? process.env.PSL_ENV : window?.ENV?.PSL_ENV;
// Urls
export const HOSTS = {
    psl: {
        live: 'https://pagespeedlog.com',
        local: 'http://localhost:3000',
        staging: 'https://staging.pagespeedlog.com',
        tunnel: 'https://tpsl.pagespeedlog.com',
    },
    lgh: {
        live: 'https://lgh.pagespeedlog.com',
        local: 'http://localhost:3002',
        staging: 'https://lghs.pagespeedlog.com',
        tunnel: 'https://tlgh.pagespeedlog.com',
    },
    img: {
        live: 'https://img.pagespeedlog.com',
    },
    img2: {
        live: 'https://i.pagespeedlog.com',
    },
    tech: {
        live: 'https://tech.pagespeedlog.com',
    },
    socket: {
        live: 'wss://pagespeedlog.com',
        local: 'ws://localhost:3000',
        staging: 'wss://staging.pagespeedlog.com',
        tunnel: 'wss://tpsl.pagespeedlog.com',
    },
};
export const MAIN_HOST = PSL_ENV === 'local'
    ? HOSTS.psl.local
    : PSL_ENV === 'live'
        ? HOSTS.psl.live
        : HOSTS.psl.staging;
export const SOCKET_HOST = PSL_ENV === 'local'
    ? HOSTS.socket.local
    : PSL_ENV === 'live'
        ? HOSTS.socket.live
        : HOSTS.socket.staging;
export const SOCKET_URL_OBJ = {
    live: `${HOSTS.socket.live}/app/status`,
    local: `${HOSTS.socket.local}/app/status`,
    staging: `${HOSTS.socket.staging}/app/status`,
    tunnel: `${HOSTS.socket.tunnel}/app/status`,
};
export const SOCKET_URL = PSL_ENV === 'local'
    ? SOCKET_URL_OBJ.local
    : PSL_ENV === 'live'
        ? SOCKET_URL_OBJ.live
        : SOCKET_URL_OBJ.staging;
export const SOCKET_PATH = '/app/status';
export const PSL_STATE_URL_OBJ = {
    live: `${HOSTS.psl.live}/app/queue/state`,
    local: `${HOSTS.psl.local}/app/queue/state`,
    staging: `${HOSTS.psl.staging}/app/queue/state`,
    tunnel: `${HOSTS.psl.tunnel}/app/queue/state`,
};
// How many report runner machines we have
export const MACHINE_COUNT = 3;
export const ERRS = {
    mystery: 'MYSTERY_ERROR',
    general: 'SOMETHING_WENT_WRONG',
    retry: 'ALL_RETRIES_FAILED',
    timeout: 'TIMEOUT',
};
// NOTE: order matters
export const LH_CATS = ['performance', 'best-practices', 'seo', 'accessibility'];
export const CATS = [
    'performance',
    'best-practices',
    'seo',
    'accessibility',
];
export const CAT_VALUES = [
    'all',
    'default',
    'graphs',
    'info',
    'manual',
    'na',
    'passed',
    'weak',
    'util',
];
export const INTERVALS = [
    'never',
    'every-minute',
    'every-hour',
    'every-day',
    'every-2-days',
    'every-3-days',
    'every-4-days',
    'every-5-days',
    'every-6-days',
    'every-7-days',
    'every-30-days',
];
export const FORM_FACTORS = ['mobile', 'desktop'];
export const MODES = ['dark', 'light'];
export const DEFAULT_MODE = 'dark';
// A list of screenshots that are basically blank, usually the firs image. We
// can use this list to skip rendering and processing of these images
export const BLANK_MOBILE_IMAGES = [
    '37e9db14bcc310d01c50781e04113982.jpg',
    '319db335dadaf8c9257de7cf11916528.jpg',
    'eb4a243ec894b7222aada655fee0ff4b.jpg',
    'dc519a38815be8e2d404705cfd917973.jpg',
    '0c99f7766761dac0c49e303184b2a7f6.jpg',
    '52e106079844463edc2e18c21cbc221d.jpg',
    'b1573a8f9f3c67cfb005918289ebc415.jpg',
    'ff2162bd7dbdf9cb50113ee173ed3324.jpg',
    '293c5105d5a3a6f7e475af2106d80fe3.jpg',
    'dd28546a3e807e6d1b3e187ed8347d1b.jpg',
    '5bbc2badaf4adfe190473d238ae55fd1.jpg',
    '6d76391beb2e84c5f8b79c65e4d88521.jpg',
    '6ef1692cd08f7af0236dbaadb8b81a58.jpg',
];
export const BLANK_DESKTOP_IMAGES = [
    '37e9db14bcc310d01c50781e04113982.jpg',
    '319db335dadaf8c9257de7cf11916528.jpg',
    '4c7378ffb0ff9b582a7a4765b5fa30d1.jpg',
    '3596e6a18d9324d1091b361e8695650d.jpg',
];
export const BLANK_IMAGES = BLANK_MOBILE_IMAGES.concat(BLANK_DESKTOP_IMAGES);
export const emailSelectors = {
    type: 'input[type=email]',
    name: 'input[name=email]',
    name2: 'input[name=email-address]',
    name3: 'input[name=emailAddress]',
    id: 'input#email',
    id2: 'input#email-address',
};
export const usernameSelectors = {
    name: 'input[name=username]',
    name2: 'input[name=user]',
    id: 'input#username',
    id2: 'input#user',
};
export const passwordSelectors = {
    type: 'input[type=password]',
    name: 'input[name=password]',
    id: 'input#password',
};
export const submitSelectors = {
    button: 'button[type=submit]',
    input: 'input[type=submit]',
};
export const EMPTY_SCREENSHOT_NODE = {
    id: '',
    top: 0,
    left: 0,
    right: 0,
    width: 0,
    bottom: 0,
    height: 0,
};
// QUEUED is basically the QStash event CREATED
export const DEFAULT_STATE = 'IDLE';
export const ON_STATES = ['ACTIVE', 'QUEUED'];
export const ERR_STATES = ['ERROR'];
export const DONE_STATES = ['DELIVERED'];
export const END_STATES = [...ERR_STATES, ...DONE_STATES];
export const STATES = [
    DEFAULT_STATE,
    ...ON_STATES,
    ...ERR_STATES,
    ...DONE_STATES,
];
export const FORMAT_TO_SUBTYPE = {
    webp: 'webp',
    jpg: 'jpeg',
    jpeg: 'jpeg',
    png: 'png',
    gif: 'gif',
    svg: 'svg+xml',
};
export const CF_SCREENSHOT_URLS = {
    mobile: `${HOSTS.img2.live}/cdn-cgi/image/format=webp,quality=60,width=201,height=399/${HOSTS.img.live}`,
    desktop: `${HOSTS.img2.live}/cdn-cgi/image/format=webp,quality=60,width=500,height=348/${HOSTS.img.live}`,
};
